
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取sap左侧部门树
export function getSapDeptList (parameter) {
  return axios({
    // url: sysInfo.apiRemote + '/asset/getZCDICT',
    url: '/data/relevant.json',
    method: 'GET',
    params: parameter
  })
}

// 获取sap右侧选中数据
export function getSapData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevant',
    method: 'GET',
    params: parameter
  })
}

// 保存sap右侧选中数据
export function setSapData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevant',
    method: 'PUT',
    data: parameter
  })
}
